var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiAwardStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 12,
    width: 13,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon-ui--award-star_svg__a",
    height: 12,
    maskUnits: "userSpaceOnUse",
    width: 13,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.813 0h12v12h-12z",
    fill: "#d9d9d9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-ui--award-star_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.35 8.125l1.463-.887 1.462.887-.387-1.662 1.3-1.125L7.475 5.2l-.662-1.575L6.15 5.2l-1.712.138 1.3 1.125zm1.463 3.525L5.138 10H2.813V7.675L1.163 6l1.65-1.675V2h2.325L6.813.35 8.488 2h2.325v2.325L12.463 6l-1.65 1.675V10H8.488zm0-1.4L8.063 9h1.75V7.25L11.063 6l-1.25-1.25V3h-1.75l-1.25-1.25L5.563 3h-1.75v1.75L2.563 6l1.25 1.25V9h1.75z",
    fill: "#fff"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--award-star-5be23de1ab95c75afa3d37516fb71105.svg";
export { SvgIconUiAwardStar as Component };